import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type ContributePageHeadingProps = {
  eyebrow: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function ContributePageHeading({
  eyebrow,
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
}: ContributePageHeadingProps) {
  return (
    <section className={cn('space-y-5', className)}>
      <div className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-faint-foreground">
        <span>{eyebrow}</span>
      </div>
      <div className="space-y-4">
        <h1 className={cn('max-w-3xl font-semibold leading-tight tracking-tight text-foreground text-3xl sm:text-4xl', titleClassName)}>
          {title}
        </h1>
        {description ? (
          <p className={cn('max-w-2xl text-base leading-7 text-muted-foreground', descriptionClassName)}>
            {description}
          </p>
        ) : null}
      </div>
    </section>
  );
}
